import React from 'react';
import { CategoryCard } from './CategoryCard';
import { ZapIcon, MonitorIcon, UserIcon, ActivityIcon, HandIcon, ShirtIcon, ShieldIcon, TargetIcon, AwardIcon } from 'lucide-react';
export function ShopByCategory() {
  const categories = [{
    title: 'Gen 3 Launch',
    icon: <ZapIcon className="w-8 h-8" data-id="element-185" />
  }, {
    title: 'Electronic Scoring',
    icon: <MonitorIcon className="w-8 h-8" data-id="element-186" />
  }, {
    title: 'Head Gear',
    icon: <UserIcon className="w-8 h-8" data-id="element-187" />
  }, {
    title: 'E-Foot Gear',
    icon: <ActivityIcon className="w-8 h-8" data-id="element-188" />
  }, {
    title: 'Gloves',
    icon: <HandIcon className="w-8 h-8" data-id="element-189" />
  }, {
    title: 'Uniforms & Apparel',
    icon: <ShirtIcon className="w-8 h-8" data-id="element-190" />
  }, {
    title: 'Protective Gear',
    icon: <ShieldIcon className="w-8 h-8" data-id="element-191" />
  }, {
    title: 'Training & Accessories',
    icon: <TargetIcon className="w-8 h-8" data-id="element-192" />
  }, {
    title: 'Wacoku Products',
    icon: <AwardIcon className="w-8 h-8" data-id="element-193" />
  }];
  return <section className="py-20 bg-white" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-12" data-id="element-196">
          <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-197">
            Shop by Category
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-4" data-id="element-198"></div>
          <p className="mt-4 text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-199">
            Find exactly what you need with our structured shopping paths.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6" data-id="element-200">
          {categories.slice(0, 5).map((category, index) => <CategoryCard key={index} title={category.title} icon={category.icon} data-id="element-201" />)}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 mt-4 lg:mt-6" data-id="element-202">
          {categories.slice(5).map((category, index) => <CategoryCard key={index + 5} title={category.title} icon={category.icon} data-id="element-203" />)}
        </div>
      </div>
    </section>;
}